/* template */
<template><div class="tabs"><div :class="({'empty':tabsData?.length<=1})" class="tabs-header"><template v-if="(tabsData.length>1)"><mpx-view v-for="(item, index) in (tabsData)" :key="item.key" :class='("tabs-header-item "+(currentTab === index ? "active" : ""))' @tap="onTabClick(item, index)"><span class="text">{{item.name}}</span></mpx-view></template></div><div :style="[(tabTransformStyle)] | transRpxStyle" class="tabs-container"><div v-for="(item, index) in (tabContents)" :key="item.key" class="tabs-container-item"><component :is="(item.comp)" :mixinShowProp="(index === currentTab)"/></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"me8fca082"}'>
.tabs
  height auto
  overflow hidden
  &-header
    width calc(100% - 20px)
    margin-left 10px
    height 62px
    display flex
    align-items center
    padding-bottom 16px
    background-color #F2F6F9
    border-top-left-radius 16px
    border-top-right-radius 16px
    overflow hidden
    box-sizing border-box
    border 2px solid #fff
    border-bottom 0
    &.empty
      height 0
    &-item
      flex 1
      height 100%
      position relative
      @extend .flex-center
      justify-content center
      .text
        z-index 1
      &.active
        &::before, &::after
          content ''
          position absolute
          display block
        &::after
          bottom -16px
          width 100%
          height 16px
          background #fff
        &::before
          width calc(100% + 20px)
          height 100%
          background-image url('https://ut-static.udache.com/webx/sfc/TO6Yk4wEaXNAvow9Tx1TE.png')
          background-position center top
          background-repeat no-repeat
          background-size 100% 100%
        &:first-child
          &::before
            width calc(100% + 10px)
            background-image url('https://ut-static.udache.com/webx/sfc/ubGBzLUZ-S09L-Eb3wCBZ.png')
            left 0
        &:last-child
          &::before
            width calc(100% + 10px)
            background-image url('https://ut-static.udache.com/webx/sfc/oxGkIcQicqRvJ08wSOxGJ.png')
            right 0
  &-container
    width 100%
    height auto
    display flex
    transition-timing-function cubic-bezier(0.165, 0.84, 0.44, 1)
    transition-property transform
    transition-duration 300ms
    transform translateX(0) translateY(-16px) translateZ(1px)
    &-item
      box-sizing border-box
      overflow hidden
      width 100%
      flex none
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "me8fca082"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexe8fca082%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexe8fca082%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["me8fca082"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexe8fca082/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'train-home-comp':getComponent(require("../train-home/index.mpx?isComponent&outputPath=components%2Findex89b8fdf6%2Findex")),'flights-home-comp':getComponent(require("../flights-home/index.mpx?isComponent&outputPath=components%2Findex3d75fc2c%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
